import {
  BreakpointQueryName, SpacingName, ThemedFunctor, grid, gridUnit,
} from '@doveit/lego';
import { css } from 'styled-components';

export const services: ThemedFunctor = ({ theme }) => css`
  ${grid(theme, {
    gutter: SpacingName.SMALLER,
  })}
`;

export const servicesBlock: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, {
    gutter: SpacingName.SMALLER,
    size: {
      LG: 3 / 5,
    },
  })}
`;

export const servicesImage: ThemedFunctor = ({ theme }) => css`
  display: none;
  ${gridUnit(theme, { size: { LG: 2 / 5 } })}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: block;
    padding: ${theme.spaceUnits.desktop.SMALLER};
  }
`;

export const servicesList: ThemedFunctor = ({ theme }) => css`
  ${grid(theme, {
    gutter: SpacingName.SMALL,
  })}
`;

export const serviceItem: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, {
    gutter: SpacingName.SMALL,
    size: {
      MD: 1 / 2,
    },
  })}
`;

export const packageList: ThemedFunctor = ({ theme }) => css`
  ${grid(theme, {
    gutter: SpacingName.SMALLER,
  })}
`;

export const packageItem: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, {
    gutter: SpacingName.SMALLER,
    size: {
      LG: 1 / 3,
    },
  })}
`;
